import { TaggedError } from "@for-it/domain-lib";
export class BucketOperationFailedError extends TaggedError {
    constructor() {
        super("BucketOperationFailedError");
    }
}
